export default __webpack_public_path__ + "static/media/bg7.e7339b12.jpg";